// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"d229b3e8","487":"6a7164d1","884":"8631a15b"}[chunkId] + ".chunk.css";
};